import { BaseUseCase } from "../UseCaseBase";
class ServerKeyUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult() {
        return await this.repo.getServerKey();
    }
}
export default ServerKeyUseCase;
